angular.module('lsnBase.models')
  .factory('LsnOrganizationModelConstants', [function()
  {
    var OrganizationModelConstants = {};
    OrganizationModelConstants.ORGANIZATION_INDUSTRY_CODE_DEFAULT = '07'; // INNE
    OrganizationModelConstants.ORGANIZATION_LEGALFORM_CODE_DEFAULT = '44'; // INNA

    return OrganizationModelConstants;
  }]);